<template>
    <b-modal size="lg" id="ModalShipOrder" hide-footer no-close-on-esc no-close-on-backdrop hide-header centered>
        <EditShipOrder v-if="action.action === 'editShipOrder'" :action="action"> </EditShipOrder>
    </b-modal>
</template>

<script>
import EditShipOrder from "../actions/EditShipOrder";

export default {
    props: ["action", "actionShipOrder"],
    data() {
        return {};
    },
    components: {
        EditShipOrder
    }
};
</script>



// WEBPACK FOOTER //
// ModalShipOrder.vue?72aafbac